/**
 * Ficha de la gift card (sections/main-gift-card-product.liquid).
 * - Importe: el radio checked es el input name="id" del formulario; aquí solo
 *   se actualizan el importe grabado en la tarjeta, el botón de añadir y la URL.
 * - Tarjeta: lo escrito en "Para" se graba al momento en la esquina inferior
 *   derecha, y la tarjeta se inclina con el puntero (nunca sola; con
 *   prefers-reduced-motion se queda quieta).
 * - Modo de envío: dos opciones ("a mí" / "a quien la recibe") que no viajan
 *   con el pedido. "A quien la recibe" activa la propiedad nativa
 *   __shopify_send_gift_card_to_recipient y los campos de destinatario de
 *   Shopify; "a mí" la desactiva, "Para" y "Mensaje" pasan a _To y _Message
 *   y el email, la fecha y el offset se desactivan (no se envían).
 */
if (!customElements.get('gift-card-product-recipient')) {
  class GiftCardProductRecipient extends HTMLElement {
    connectedCallback() {
      this.modes = this.querySelectorAll('[data-gcp-mode]');
      this.native = this.querySelector('[data-gcp-native]');
      this.emailFields = this.querySelector('[data-gcp-email-fields]');
      this.offset = this.querySelector('[data-gcp-offset]');
      this.sendOn = this.querySelector('[data-gcp-send-on]');
      this.renamable = this.querySelectorAll('[data-name-recipient][data-name-self]');

      if (this.offset) this.offset.value = new Date().getTimezoneOffset().toString();
      if (this.sendOn) {
        const now = new Date();
        const pad = (n) => String(n).padStart(2, '0');
        this.sendOn.min = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
      }

      this.modes.forEach((mode) => mode.addEventListener('change', () => this.sync()));
      this.sync();
    }

    sync() {
      const checked = Array.from(this.modes).find((mode) => mode.checked);
      const toRecipient = checked ? checked.value === 'recipient' : false;

      // Un campo o fieldset desactivado no se envía ni exige el email.
      this.native.disabled = !toRecipient;
      this.emailFields.disabled = !toRecipient;
      this.emailFields.hidden = !toRecipient;
      if (this.offset) this.offset.disabled = !toRecipient;

      this.renamable.forEach((field) => {
        field.name = toRecipient ? field.dataset.nameRecipient : field.dataset.nameSelf;
      });
    }
  }

  customElements.define('gift-card-product-recipient', GiftCardProductRecipient);
}

document.addEventListener('input', (evt) => {
  if (!evt.target.matches || !evt.target.matches('[data-gcp-to]')) return;
  const name = evt.target.closest('.gcp')?.querySelector('[data-gc-card-name]');
  if (name) name.textContent = evt.target.value.trim();
});

const gcpReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

document.querySelectorAll('[data-gcp-tilt]').forEach((media) => {
  const card = media.querySelector('.gc-card');
  if (!card) return;

  const reset = () => {
    card.style.removeProperty('--gc-rx');
    card.style.removeProperty('--gc-ry');
    card.style.removeProperty('--gc-sheen');
  };

  media.addEventListener('pointermove', (evt) => {
    if (gcpReducedMotion.matches) return;
    const rect = media.getBoundingClientRect();
    const x = ((evt.clientX - rect.left) / rect.width - 0.5) * 2;
    const y = ((evt.clientY - rect.top) / rect.height - 0.5) * 2;
    card.style.setProperty('--gc-ry', `${(x * 12).toFixed(2)}deg`);
    card.style.setProperty('--gc-rx', `${(-y * 10).toFixed(2)}deg`);
    card.style.setProperty('--gc-sheen', `${(x * 18).toFixed(2)}%`);
  });
  media.addEventListener('pointerleave', reset);
  media.addEventListener('pointercancel', reset);
});

document.addEventListener('change', (evt) => {
  const input = evt.target;
  if (!input.classList || !input.classList.contains('gcp__amount-input')) return;

  const section = input.closest('.gcp');
  const add = section.querySelector('[data-gcp-add]');
  if (add) add.disabled = input.disabled;

  const cardAmount = section.querySelector('[data-gc-card-amount]');
  const label = input.closest('.gcp__amount')?.querySelector('.gcp__amount-text');
  if (cardAmount && label) cardAmount.textContent = label.textContent.trim();

  const url = new URL(window.location.href);
  url.searchParams.set('variant', input.value);
  window.history.replaceState({}, '', url.toString());
});
